import React, { useEffect, useRef, useState } from "react";
import DatePicker, {
  DateObject,
  getAllDatesInRange,
} from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import "./rangePicker.css";


export default function RangePicker({ rangeValue, setRangeValue }) {


  const [inputWidth, setInputWidth] = useState(100);
  const [isFocused, setIsFocused] = useState(false); 
  const spanRef = useRef(null);

  const updateInputWidth = (text) => {
    if (spanRef.current) {
      spanRef.current.innerHTML = text;
      const newWidth = spanRef.current.offsetWidth + 28;
      setInputWidth(newWidth);
    }
  };

  useEffect(() => {
    if (rangeValue[0] && rangeValue[1]) {
      const currentText = `${rangeValue[0].toLocaleString("default", {
        month: "long",
        year: "numeric",
      })} - ${rangeValue[1].toLocaleString("default", {
        month: "long",
        year: "numeric",
      })}`;
      updateInputWidth(currentText);
    }
  }, [rangeValue]);

  return (
    <div
      className={`floating-label-wrapper ${
        isFocused || rangeValue[0] ? "focused" : ""
      }`}
    >
      <span
        ref={spanRef}
        style={{
          visibility: "hidden",
          whiteSpace: "nowrap",
          position: "absolute",
        }}
      ></span>

      <label className="floating-label">Month & Year</label>

      <DatePicker
        onlyMonthPicker
        range
        format="MMMM YYYY"
        value={rangeValue}
        onChange={setRangeValue}
        onOpen={() => setIsFocused(true)}
        onClose={() => setIsFocused(false)}
        style={{
          width: `${inputWidth}px`,
          minWidth: "100px",
          height: "56px",
          margin: "0",
          padding: "0 12px",
          boxSizing: "border-box",
        }}
        plugins={[<DatePanel />]}
      />
    </div>
  );
}
